import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hide-on-scroll"
export default class extends Controller {
  static targets = ["primary", "delayed"]
  static values = {
    offset: { type: Number, default: 24 },
    duration: { type: Number, default: 300 },
    delay: { type: Number, default: 90 },
    overlap: { type: Number, default: 40 }
  }

  connect() {
    this.lastScrollY = window.scrollY
    this.ticking = false

    this.handleScroll = this.onScroll.bind(this)
    this.handleResize = this.show.bind(this)

    this.primaryTargets.forEach((target) => {
      target.style.transition = `transform ${this.durationValue}ms ease`
      target.style.willChange = "transform"
    })

    this.delayedTargets.forEach((target) => {
      target.style.transition = `transform ${this.durationValue}ms ease ${this.delayValue}ms`
      target.style.willChange = "transform"
    })

    window.addEventListener("scroll", this.handleScroll, { passive: true })
    window.addEventListener("resize", this.handleResize)

    this.applyTransitionDelays({ primaryDelay: 0, delayedDelay: 0 })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener("resize", this.handleResize)

    if (this.frame) cancelAnimationFrame(this.frame)

    this.primaryTargets.forEach((target) => {
      target.style.transition = ""
      target.style.willChange = ""
      target.style.transform = ""
    })

    this.delayedTargets.forEach((target) => {
      target.style.transition = ""
      target.style.willChange = ""
      target.style.transform = ""
    })
  }

  onScroll() {
    if (this.ticking) return

    this.ticking = true
    this.frame = requestAnimationFrame(() => {
      this.ticking = false
      this.update()
    })
  }

  update() {
    const currentScrollY = Math.max(window.scrollY, 0)

    if (currentScrollY <= this.offsetValue) {
      this.show()
    } else if (currentScrollY > this.lastScrollY) {
      this.hide()
    } else if (currentScrollY < this.lastScrollY) {
      this.show()
    }

    this.lastScrollY = currentScrollY
  }

  hide() {
    this.applyTransitionDelays({ primaryDelay: 0, delayedDelay: this.staggerDelay() })

    this.primaryTargets.forEach((target) => {
      target.style.transform = `translate3d(0, -${this.hiddenOffsetFor(target)}px, 0)`
    })

    this.delayedTargets.forEach((target) => {
      target.style.transform = `translate3d(0, -${this.hiddenOffsetFor(target)}px, 0)`
    })
  }

  show() {
    this.applyTransitionDelays({ primaryDelay: this.staggerDelay(), delayedDelay: 0 })

    this.primaryTargets.forEach((target) => {
      target.style.transform = "translate3d(0, 0, 0)"
    })

    this.delayedTargets.forEach((target) => {
      target.style.transform = "translate3d(0, 0, 0)"
    })
  }

  applyTransitionDelays({ primaryDelay, delayedDelay }) {
    this.primaryTargets.forEach((target) => {
      target.style.transition = `transform ${this.durationValue}ms ease ${primaryDelay}ms`
    })

    this.delayedTargets.forEach((target) => {
      target.style.transition = `transform ${this.durationValue}ms ease ${delayedDelay}ms`
    })
  }

  hiddenOffsetFor(target) {
    return target.offsetTop + target.offsetHeight
  }

  staggerDelay() {
    return Math.max(this.delayValue - this.overlapValue, 0)
  }
}
